import { useRef, useEffect } from 'react';
import { Tag as OrbitTag } from '@kiwicom/orbit-components';

type Props = {
  onRemove: (arg0: string) => void;
  value: string;
  label: string;
  isLast: boolean;
};

const Tag = ({ onRemove, value, label, isLast }: Props): JSX.Element => {
  const tagRef = useRef(null);
  useEffect(() => {
    const { current } = tagRef;

    if (isLast && current != null) {
      current.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
        inline: 'end',
      });
    }
  }, [isLast]);
  return (
    <OrbitTag ref={tagRef} selected onRemove={() => onRemove(value)} dataTest={`${value}-${label}`}>
      {label}
    </OrbitTag>
  );
};

export default Tag;
